module.exports = __webpack_public_path__ + "static/media/fm.52297de2.svg";